import React, { Fragment } from 'react';

import formatDate from 'helpers/formatDate';

import CountryFlag from 'components/base/CountryFlag/index';
import Box from 'components/elements/Box';
import MobileSortingControls from 'components/data-visualization/Table/Sort';
import P from 'components/elements/p';
import theme from 'styles/themes/variables';
import { Item, Label, List, ListItem } from './styles';

import { ICountryFlagProps } from 'types/shared';
import { IConcert } from './types';
import { IMetric } from 'maps/metrics';
import { IMobileHeader } from 'components/Concerts/utils/getMobileItems';

interface IListProps {
  changeSortMetric: any;
  concerts: IConcert[];
  countries: ICountryFlagProps[];
  isLargeScreen: boolean;
  mobileItems: IMobileHeader[];
  sortMetric: IMetric | undefined;
  sortOrder: string;
  switchSortOrder: () => void;
}

const ConcertsList: React.FC<IListProps> = ({
  changeSortMetric,
  concerts,
  countries,
  isLargeScreen,
  mobileItems,
  sortMetric,
  sortOrder,
  switchSortOrder,
}) => {
  const itemToString = (item: any): string | false => {
    if (item) {
      return `${item.value}-${item.sortOrder}`;
    }
    return false;
  };

  return (
    <Box>
      <MobileSortingControls
        hide={isLargeScreen}
        sortOrder={sortOrder}
        handleToggle={switchSortOrder}
        handleDropdown={changeSortMetric}
        dropdownItems={mobileItems}
        activeItem={sortMetric}
        itemToString={itemToString}
        isToggleCaret={true}
        isToggleShown={false}
        buttonTextColor={theme.colors.White}
      />

      <List>
        {concerts &&
          concerts.map((item: IConcert, index: number) => {
            const countryMetadata = countries.find(
              (country: ICountryFlagProps) =>
                country?.displayName === item?.countryName
            );
            return (
              <Fragment key={`${item?.date}-${index}`}>
                <ListItem>
                  <Item>
                    <Label>date</Label>
                    <P m={0}>{formatDate(item?.date, 'day-short', false)}</P>
                  </Item>

                  <Item>
                    <Label>country</Label>
                    <Box display="flex" alignItems="baseline">
                      {countryMetadata && (
                        <CountryFlag small {...countryMetadata} />
                      )}
                      <P m={0}>{item?.countryName}</P>
                    </Box>
                  </Item>

                  <Item>
                    <Label>city</Label>
                    <P>{item?.cityName}</P>
                  </Item>

                  <Item>
                    <Label>venue</Label>
                    <P>{item?.venue}</P>
                  </Item>

                  <Item>
                    <Label>name</Label>
                    <P>{item?.tourName}</P>
                  </Item>
                </ListItem>
              </Fragment>
            );
          })}
      </List>
    </Box>
  );
};

export default ConcertsList;
